module.exports = __webpack_public_path__ + "img/1559568065.b80ac5a4.jpg";